module.exports = new __parcel__URL__("chtilug.6cb02270.webp").toString();